import $ from 'jquery';
$(function () {
  if (window.location.hash) {
    setTimeout(init, 250);
  }
  function init() {
    var $target = $(window.location.hash);
    if (!$target || !$target.length) {
      return;
    }
    scrollTo($target);
  }
  function scrollTo($target) {
    $('html, body').animate({
      scrollTop: $target.offset().top
    }, 600);
  }
});